import commonApi from './CommonApi.js';

export default {
	addToFavorite: async (viewModel) => {
		return await commonApi().put('/v1/userNotifications/addToFavorite', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	isFavorite: async (parameters) => {
		return await commonApi().get('/v1/userNotifications/isFavorite', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	getAllTags: async (parameters) => {
		return await commonApi().get('/v1/userNotifications/getAllTags', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
}